module.exports = __webpack_public_path__ + "static/media/360-1.4337e0eb.jpg";